<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-lg white">
          <v-row>
            <v-col cols="12">
              <v-tabs class="rounded-lg white--text" background-color="secondary"
                      active-class="primary" color="#FF8700">

                <v-tab class="white--text mr-5">
                  <span>دعوت نامه</span>
                </v-tab>
                <v-tab class="white--text mr-5">
                  <span>لیست دعوت ها</span>
                </v-tab>

                <v-tab-item class="pt-4">
                  <user-invitations></user-invitations>
                </v-tab-item>
                <v-tab-item class="pt-4">
                  <user-invitations-list></user-invitations-list>
                </v-tab-item>
              </v-tabs>

            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>


import UserInvitations from "@/views/panel/user/UserInvitations";
import UserInvitationsList from "@/views/panel/user/UserInvitationsList";
export default {
  name: "UserInvitationsTab",
  components: {
    UserInvitationsList,
    UserInvitations
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {

  },
  computed: {
  },

}
</script>

<style scoped lang="scss"></style>

